import React from 'react';
export default function ReconTrend({ series }: Readonly<{ series: any[] }>) {
  if (!series?.length) return <div style={{ color: '#6b7280' }}>No data</div>;
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {series.map((s: any) => (
        <div key={s.name} style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 8 }}>
          <div style={{ fontSize: 12, color: '#6b7280' }}>{s.name}</div>
          <div style={{ display: 'flex', gap: 4, alignItems: 'flex-end' }}>
            {s.points.map((p: any, i: number) => (
              <div
                key={i}
                title={`${p.date}: ${p.value}`}
                style={{ width: 10, height: Math.max(2, Number(p.value) || 0) }}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
